@import 'styles/mixins';
@import 'styles/variables';

.root {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 0 0 auto;

  &.collapsed {
    margin-left: 100px;
    width: 400px;
  }
}

.headerLabel {
  @include lg-semibold;
}

.upperHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
}

.icon {
  margin-right: 6px;
}
